import { render, staticRenderFns } from "./OportunityContent.vue?vue&type=template&id=73744fa6&"
import script from "./OportunityContent.vue?vue&type=script&lang=ts&"
export * from "./OportunityContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports